import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Label } from "../ui/label";

export function OrderCancelReasonDialog({
    open,
    onOpenChange,
    orderCancelReasons,
    onConfirm
}) {
    const [selectedReasonId, setSelectedReasonId] = useState("");

    const handleConfirm = () => {
        if (!selectedReasonId) {
            return;
        }

        const selectedReason = orderCancelReasons.find(
            reason => reason.OrderCancelReasonId?.toString() === selectedReasonId
        );

        if (selectedReason) {
            onConfirm(selectedReason);
            setSelectedReasonId("");
        }
    };

    const handleCancel = () => {
        setSelectedReasonId("");
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Select Order Cancel Reason</DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <div className="grid gap-2">
                        <Label htmlFor="reason">Reason *</Label>
                        {orderCancelReasons && orderCancelReasons.length > 0 ? (
                            <div className="grid grid-cols-1 gap-2 max-h-[300px] overflow-y-auto">
                                {orderCancelReasons.map((reason) => {
                                    const reasonId = reason.OrderCancelReasonId?.toString();
                                    const isSelected = selectedReasonId === reasonId;
                                    return (
                                        <Button
                                            key={reason.OrderCancelReasonId}
                                            type="button"
                                            variant={isSelected ? "default" : "outline"}
                                            onClick={() => setSelectedReasonId(reasonId)}
                                            className={`w-full justify-start text-left ${isSelected
                                                ? "bg-primary text-primary-foreground"
                                                : "hover:bg-accent"
                                                }`}
                                        >
                                            {reason.OrderCancelReasonName || "Unknown Reason"}
                                        </Button>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="text-sm text-muted-foreground py-4 text-center">
                                No cancel reasons available
                            </div>
                        )}
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} disabled={!selectedReasonId}>
                        Confirm
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

